import React from 'react'

import { Button, Modal, P } from '@driftt/tide-core'

import { DeserializedSavedFilter } from 'api/AccountActivityAPI/types'
import Portal from 'components/Portal'

interface DeleteFilterModalProps {
  onClose: () => void
  isModalOpen: boolean
  savedFilter: DeserializedSavedFilter
  onRemoveSavedFilter: (id: number) => void
}

const DeleteFilterModal: React.FC<DeleteFilterModalProps> = ({
  onClose,
  isModalOpen,
  savedFilter,
  onRemoveSavedFilter
}) => {
  const onDeleteSavedFilter = async () => {
    await onRemoveSavedFilter(savedFilter.id)
    onClose()
  }

  return (
    <Portal>
      <Modal
        title={`Are you sure you want to delete ${savedFilter.name}?`}
        open={isModalOpen}
        onClose={onClose}
        size="small"
        type="warning"
        footerCopy={
          <>
            <Button type="secondary" onClick={onDeleteSavedFilter}>
              Delete
            </Button>
            <Button type="tertiary" onClick={onClose}>
              Cancel
            </Button>
          </>
        }>
        <P>
          Activity and accounts in this view will still exist in Drift, but you will no longer be
          able to navigate to or receive any notifications for this saved filter.
        </P>
      </Modal>
    </Portal>
  )
}

export default DeleteFilterModal
